var _g;
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1504.000000, -383.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Multi-color",
    transform: "translate(1120.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-3",
    transform: "translate(0.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Home/Multicolour/Colourful",
    transform: "translate(384.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.001402, 2.666665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.998609,17.9829309 L13.998609,14.0000111 L13.998609,14.0000111 C13.998609,13.6318208 13.7001321,13.3333439 13.3319418,13.3333439 L10.665273,13.3333439 L10.665273,13.3333439 C10.2970827,13.3333439 9.99860582,13.6318208 9.99860582,14.0000111 C9.99860582,14.0000111 9.99860582,14.0000111 9.99860582,14.0000111 L9.99860582,17.987931 L9.99860582,17.9879393 C9.99860582,18.3548317 9.70215142,18.652769 9.33526362,18.6545982 L4.66525989,18.6666814 L4.66525986,18.6666814 C4.29706956,18.6666814 3.99859266,18.3682045 3.99859266,18.0000142 C3.99859266,18.0000142 3.99859266,18.0000142 3.99859266,18.0000142 L3.99859266,11.1691754 L11.6815155,4.84208702 L11.6815154,4.84208706 C11.8675589,4.69212652 12.1329741,4.69212652 12.3190159,4.84208698 L19.9986054,11.1666754 L19.9986054,18.0000142 L19.9986054,18.0000142 C19.9986054,18.3682045 19.7001285,18.6666814 19.3319382,18.6666814 L14.6652678,18.6537647 L14.6652678,18.6537647 C14.2970775,18.6537719 13.9985927,18.3553007 13.9985927,17.98711 C13.9985927,17.9857168 13.9985927,17.9843235 13.9985927,17.9829303 L13.998609,17.9829309 Z",
    id: "path_secondary",
    fill: "#98A6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8869503,9.84792444 L22.8244494,11.1395921 L22.8244494,11.1395921 C22.649208,11.3530057 22.3341407,11.3839498 22.120728,11.2087089 C22.1205793,11.2085868 22.1204307,11.2084646 22.1202821,11.2083423 L12.3190243,3.13375249 L12.3190243,3.1337525 C12.1329808,2.98379196 11.8675656,2.98379196 11.6815238,3.13375248 L1.88068262,11.2083423 L1.88068263,11.2083423 C1.66736163,11.3836903 1.35228221,11.3529099 1.17693207,11.1395922 L0.114431219,9.8479245 L0.114431198,9.84792448 C-0.0613122758,9.63504389 -0.0312830851,9.32001572 0.181514585,9.14417392 L10.7273564,0.458333633 L10.7273563,0.458333642 C11.4656611,-0.149216844 12.5307203,-0.149216844 13.269025,0.458333625 L16.9986114,3.52541941 L16.9986114,0.5 L16.9986114,0.5 C16.9986113,0.223857679 17.222469,-4.70734562e-14 17.4986118,-4.70734562e-14 L19.831947,-4.70734562e-14 L19.8319469,-4.70734562e-14 C20.1080897,-4.70734562e-14 20.3319473,0.223857679 20.3319473,0.5 L20.3319473,6.27125502 L23.8152835,9.14250731 L23.8152834,9.14250731 C24.0297607,9.31644453 24.0626249,9.63131603 23.8886877,9.84579537 C23.8881105,9.84650702 23.8875314,9.84721709 23.8869504,9.84792557 L23.8869503,9.84792444 Z",
    id: "path_primary",
    fill: "#4C69BA"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.ff1398a4.svg";
export { ForwardRef as ReactComponent };